import { PREVIOUSLY_ORDERED_SET_NAME } from '~/shared/sets/constants'
import type { GalleryModelsUrl } from 'shared/types/gallery/models'

export const isPreviouslyOrderedTemplate = (rankingSet?: string): boolean => {
  return rankingSet === PREVIOUSLY_ORDERED_SET_NAME
}

export const createPreviouslyOrderedSet = (designConceptId: string, designPersonalizationContextId?: string): GalleryModelsUrl.JSONObject => {
  return {
    name: PREVIOUSLY_ORDERED_SET_NAME,
    priority: 1,
    distribution: {
      type: 'positions',
      positions: [1],
      limit: 1,
    },
    ranking: {
      type: 'forced',
      rankingStrategies: [
        {
          name: '',
          sortingDirection: 'descending',
        },
      ],
    },
    filters: {
      content: {
        DesignConceptId: [designConceptId],
      },
    },
    ...(designPersonalizationContextId && { designPersonalizationContextId }),
  }
}
